import { NotificacionDTO } from './notificacion.dto';

export class SocketResultDTO {
    message: NotificacionDTO;
}